import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useGetMonthlyRevenue } from "@/api/revenue/get-monthly-revenue";
import { MonthlyRevenueChart } from "./monthly-revenue-chart";

const MonthlyRevenueChartWithData = () => {
    const currentYear = new Date().getFullYear();
    const { data: revenueData, isLoading, isError } = useGetMonthlyRevenue(currentYear);

    if (isLoading) {
        return (
            <Card className="@container/card">
                <CardHeader>
                    <CardTitle>Monthly Revenue</CardTitle>
                </CardHeader>
                <CardContent className="flex items-center justify-center h-64">
                    <p>Loading revenue data...</p>
                </CardContent>
            </Card>
        );
    }

    if (isError) {
        return (
            <Card className="@container/card">
                <CardHeader>
                    <CardTitle>Monthly Revenue</CardTitle>
                </CardHeader>
                <CardContent className="flex items-center justify-center h-64">
                    <p className="text-red-500">Error loading revenue data</p>
                </CardContent>
            </Card>
        );
    }

    if (!revenueData || revenueData.length === 0) {
        return (
            <Card className="@container/card">
                <CardHeader>
                    <CardTitle>Monthly Revenue</CardTitle>
                </CardHeader>
                <CardContent className="flex items-center justify-center h-64">
                    <p>No revenue data available</p>
                </CardContent>
            </Card>
        );
    }

    return <MonthlyRevenueChart data={revenueData} />;
};

export default MonthlyRevenueChartWithData;